module.exports = __webpack_public_path__ + "static/media/trainingsraum-weitwinkel.9f21be66.jpg";